<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :disabled="disabled"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            color="success"
            filled
            outlined
            dense
            v-model="value"
            :label="requiredCharLabel"
            append-icon="mdi-calendar"
            hide-details="auto" 
            v-bind="attrs"
            v-on="on"
            :rules="rule"
            :error-messages="errorMessages"
            :disabled="disabled"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="value"
          @input="menu = false"
        ></v-date-picker>
      </v-menu>
</template>

<script>
export default {
    props: ['valueInput', 'rule', 'label', 'errorMessages', 'disabled'],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    computed: {
        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                this.$emit('valueChange', value)
            }
        },
        requiredCharLabel:{
            get: function(){
                if(this.label == "" || this.label == undefined)
                    return "";
                const response = this.label + " *";
                for (let i = 0; i < (this?.rule?.length??[]); i++) {
                    if(this.rule[i]("") != true){
                        return response;
                    }
                }
                return this.label;
            }
        }
        
    },
    data: () =>({
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
    })
}
</script>
<style lang="scss" >
   
  
</style>